import { atom } from "jotai";

// Domain selection persists to localStorage — domain is a UI filter
// (BE / FE / Infra), not a galaxy scope. Cross-galaxy reuse of the
// last-selected domain is harmless: the auto-select fallback in each
// page validates the domain exists for the current galaxy and falls
// back to the first known domain when it doesn't.
export const selectedDomainAtom = atom<string>(
  localStorage.getItem("ace_selected_domain") || "",
);
export const selectedAuthorAtom = atom<string | null>(null);

export const setSelectedDomainAtom = atom(null, (_get, set, domain: string) => {
  set(selectedDomainAtom, domain);
  localStorage.setItem("ace_selected_domain", domain);
});
